module.exports = __webpack_public_path__ + "static/media/hasdrubal.91132346.png";